import React, { memo } from 'react';
import { v4 as uuid } from 'uuid';

import { Button } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { PIXELS_TYPES } from '../../constants/analytics';
import { sendPaidClickEvent } from '../../helpers/analyticsEvents';
import { usePixel } from '../../hooks/usePixel';
import type { IItem } from '../../interfaces/organizations';
import { Pixel } from '../Pixel';

import styles from './advertising.module.scss';

interface IProps {
  advSub?: string;
  item: IItem;
  btnText?: string;
}

export const AdvertisingButton: React.FC<IProps> = memo((props) => {
  const {
    item,
    item: {
      ad: { productType, clickLink, displayLink, buttonText, buttonMobileText },
      name,
    },
    btnText,
  } = props;

  const isMobile = useIsMobile();

  const advSub = uuid();

  const href = usePixel(clickLink, {
    sub: advSub,
    type: productType,
    organizationName: name,
    pixelType: PIXELS_TYPES.CLICK,
  });

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    sendPaidClickEvent(item);

    window.open(decodeURI(href), '_blank', 'noopener');
  };

  return (
    <a className={styles.buttonWrapper} onClick={handleClick}>
      <Pixel link={displayLink} organizationName={name} sub={advSub} />
      <Button color="dark" size={44} variant="primary" block className={styles.button}>
        {btnText || (isMobile ? buttonMobileText : buttonText)}
      </Button>
    </a>
  );
});
